import {
  useFetchChroniclesQuery,
  useCreateChronicleMutation,
  useDeleteChronicleMutation,
} from '../../store'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { Col, Divider, Form, Input, Modal, Row } from 'antd'
import { ContentCard } from '../../components/ContentCard'
import * as T from '../../components/Typography'
import { useNavigate } from 'react-router-dom'
import { Overlay } from '../../components/Overlay'
import { AiOutlineCloseSquare, AiOutlinePlusSquare } from 'react-icons/ai'
import { useEffect, useState } from 'react'
import { useForm } from 'antd/es/form/Form'
import TextArea from 'antd/es/input/TextArea'

export const AdventuresPage = () => {
  const { user } = useAuthenticator((context) => [context.user])
  const {
    data: chronicles,
    isLoading,
    isFetching,
    refetch,
  } = useFetchChroniclesQuery(user.username || '')
  const [createChronicle, chronicle] = useCreateChronicleMutation()
  const [deleteChronicle, chronicleDeletion] = useDeleteChronicleMutation()
  const [open, setOpen] = useState(false)
  const [deleteOpen, setDeleteOpen] = useState(false)
  const [buttonDisabled, setButtonDisabled] = useState(true)
  const [form] = useForm()
  const navigate = useNavigate()

  useEffect(() => {
    if (chronicle.isSuccess) refetch()
  }, [chronicle])

  useEffect(() => {
    if (chronicleDeletion.isSuccess) refetch()
  }, [chronicleDeletion])

  const confirmDeletion = (chronicle_id: string) => {
    deleteChronicle(chronicle_id)
    setDeleteOpen(false)
  }

  const handleOk = () => {
    const values = form.getFieldsValue()
    const chronicle = {
      ...values,
      dg_master_id: user.username,
    }

    createChronicle(chronicle)
    form.resetFields()
    setOpen(false)
  }

  const handleCancel = () => {
    form.resetFields()
    setOpen(false)
  }

  return (
    <>
      <Row gutter={[4, 4]}>
        <Col style={{ textAlign: 'center' }} xs={24} sm={2}>
          <h1 style={{ margin: 0 }}>Adventures</h1>
        </Col>
      </Row>
      <Divider style={{ marginTop: 12 }} />
      <Overlay
        isLoading={isLoading || isFetching || chronicle.isLoading || chronicleDeletion.isLoading}
      >
        <>
          {!isLoading && (
            <Row gutter={[8, 8]}>
              {chronicles.map((chronicle: any) => (
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 8 }} key={chronicle.id}>
                  <ContentCard>
                    <Row justify={'start'} align={'middle'}>
                      <Row
                        onClick={() => navigate(`/adventure/${chronicle.id}`)}
                        justify={'start'}
                        align={'middle'}
                        style={{ width: '100%' }}
                      >
                        <Col>
                          <T.CardTitle>{chronicle.name}</T.CardTitle>
                          <T.CardSubheader style={{ margin: '-8px 0 16px 0', color: '#999999' }}>
                            {chronicle.short_description}
                          </T.CardSubheader>
                          <Row justify={'space-between'}>
                            <T.CardDescriptionSubheader
                              style={{ marginRight: 16, paddingBottom: 8 }}
                            >
                              Creation date:{' '}
                              <span style={{ color: '#A20000' }}>
                                {new Intl.DateTimeFormat('en-US', {
                                  day: 'numeric',
                                  month: 'short',
                                  year: 'numeric',
                                }).format(new Date(chronicle.creation_date))}
                              </span>
                            </T.CardDescriptionSubheader>
                          </Row>
                        </Col>
                      </Row>
                      <Row
                        justify={'end'}
                        style={{ width: '100%' }}
                        align={'middle'}
                        onClick={() => setDeleteOpen(true)}
                      >
                        <AiOutlineCloseSquare color={'darkred'} size={24} />
                        <T.CardDescriptionSubheader
                          style={{ color: 'darkred', marginTop: 2, marginLeft: 4 }}
                        >
                          Delete Adventure
                        </T.CardDescriptionSubheader>
                      </Row>
                    </Row>
                  </ContentCard>
                  <Modal
                    title="Delete Adventure"
                    open={deleteOpen}
                    okText={'Delete Adventure'}
                    okButtonProps={{ danger: true }}
                    onOk={() => confirmDeletion(chronicle.id)}
                    onCancel={() => {
                      setDeleteOpen(false)
                    }}
                  >
                    <p>
                      Are you sure you want to delete:{' '}
                      <span style={{ fontWeight: 'bold', color: 'darkred' }}>{chronicle.name}</span>
                    </p>
                  </Modal>
                </Col>
              ))}
              <Col xs={24} sm={12} xl={8}>
                <ContentCard style={{ height: '100%' }} onClick={() => setOpen(true)}>
                  <Row justify={'start'} align={'middle'}>
                    <Row justify={'center'} align={'middle'}>
                      <Col style={{ marginRight: 16, paddingBottom: 8 }}>
                        <AiOutlinePlusSquare size={122} />
                      </Col>
                      <Col>
                        <T.CardTitle>New Adventure</T.CardTitle>
                        <T.CardSubheader style={{ color: '#999999' }}>
                          Create a new adventure from scratch
                        </T.CardSubheader>
                      </Col>
                    </Row>
                  </Row>
                </ContentCard>
              </Col>
              <Modal
                title={'Create Adventure'}
                open={open}
                onOk={handleOk}
                onCancel={handleCancel}
                okButtonProps={{ disabled: buttonDisabled }}
              >
                <Form
                  form={form}
                  validateMessages={{
                    required: '${label} is required!',
                    whitespace: '${label} cannot be empty!',
                  }}
                  onFieldsChange={() =>
                    setButtonDisabled(
                      form.getFieldsError().some((field) => field.errors.length > 0) ||
                        Object.values(form.getFieldsValue()).some(
                          (value: any) => value === '' || value === undefined || value === ' ',
                        ),
                    )
                  }
                >
                  <Form.Item
                    label={'Adventure Name'}
                    name={'name'}
                    rules={[{ whitespace: true, required: true }]}
                  >
                    <Input placeholder={'Adventure Name'} />
                  </Form.Item>
                  <Form.Item
                    label={'Adventure Description'}
                    name={'short_description'}
                    rules={[{ whitespace: true, required: true }]}
                  >
                    <TextArea placeholder={'Adventure Short Description'} />
                  </Form.Item>
                </Form>
              </Modal>
            </Row>
          )}
        </>
      </Overlay>
    </>
  )
}
